
































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { BlogPost, BlogFilters } from '@/models/BlogPost';
@Component({
    components: {}
})
export default class BlogList extends Vue {
    @Prop()
    blogPosts!: string;
    @Prop()
    tags!: string;
    @Prop()
    authors!: string;
    private posts!: Array<BlogPost>;
    private allTags!: Array<BlogFilters['tags']>;
    private allAuthors!: Array<BlogFilters['authors']>;
    private open: boolean = false;
    private openAuthorList: boolean = false;
    private selectedItems: any = { tags: [], authors: [] };

    constructor() {
        super();
        this.posts = JSON.parse(this.blogPosts);
        this.allTags = JSON.parse(this.tags);
        this.allAuthors = JSON.parse(this.authors);
    }
    get getPosts() {
        if (this.selectedItems.tags.length === 0 && this.selectedItems.authors.length === 0) return this.posts;
        return (
            this.posts &&
            this.posts.filter(
                x =>
                    x.tags.some(s => this.selectedItems.tags.includes(s)) || this.selectedItems.authors.includes(x.name)
            )
        );
    }
    clearAllFilters(): void {
        this.selectedItems.tags = [];
        this.selectedItems.authors = [];
        this.setQuerystrings('tags', undefined);
        this.setQuerystrings('authors', undefined);
    }
    private addRemoveTag(tag: string): void {
        if (!this.selectedItems.tags.includes(tag)) this.selectedItems.tags.push(tag);
        else {
            const index = this.selectedItems.tags.indexOf(tag);
            this.selectedItems.tags.splice(index, 1);
        }
        if (this.selectedItems.tags.length) this.setQuerystrings('tags', this.selectedItems['tags'].toString());
        else this.setQuerystrings('tags', undefined);
    }
    private addRemoveAuthor(author: string): void {
        if (!this.selectedItems.authors.includes(author)) this.selectedItems.authors.push(author);
        else {
            const index = this.selectedItems.authors.indexOf(author);
            this.selectedItems.authors.splice(index, 1);
        }
        if (this.selectedItems.authors.length)
            this.setQuerystrings('authors', this.selectedItems['authors'].toString());
        else this.setQuerystrings('authors', undefined);
    }

    private setQuerystrings(att: string, value?: string) {
        const currentQuery = JSON.parse(JSON.stringify(this.$route.query));
        if (value !== undefined || currentQuery[att] != undefined) {
            currentQuery[att] = value;
            this.$router.replace({
                path: this.$route.params[0],
                query: currentQuery
            });
        }
    }
    private mounted() {
        if (this.$route.query['tags'] != null) {
            this.selectedItems.tags = this.$route.query['tags'].toString().split(',');
        }
        if (this.$route.query['authors'] != null) {
            this.selectedItems.authors = this.$route.query['authors'].toString().split(',');
        }
    }
    private toggleMobileFilter(e: PointerEvent) {
        const element = e.target as HTMLElement;
        if (element !== null) {
            ((element.closest('.news-list') as HTMLElement).querySelector(
                '.filter-container'
            ) as HTMLElement).classList.toggle('toggled');
        }
    }
}
